import { requestAsync } from 'redux-query';

import endpoints from 'consts/endpoints';

type detailedTransactionReportTargetsType = {
  companyId?: string;
  currency?: string;
  errorCallback: Function;
  resultKey?: string;
};

export default ({
  companyId = '',
  currency = '',
  errorCallback,
  resultKey = 'detailedTransactionReportTargetsData',
}: detailedTransactionReportTargetsType) =>
  requestAsync({
    url: endpoints.getDetailedTransactionReportTargetsUrl(companyId, currency),
    transform: (response) => ({
      [resultKey]: response,
    }),
    queryKey: endpoints.getDetailedTransactionReportTargetsUrl(companyId, currency),
    options: {
      headers: {
        Accept: 'application/json',
      },
    },
    meta: {
      authToken: true,
      errorCallback,
    },
    update: {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [resultKey]: (_prevEntities, newEntities) => newEntities,
    },
  });
